import React from 'react';

const RecurringConfirmationModal = ({ 
  initialDate, 
  recurrenceStartDate,
  currentMonthDates, 
  endDate,
  onConfirm, 
  onCancel 
}) => {
  const monthName = new Date(recurrenceStartDate).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h2 style={styles.title}>⚠️ Confirm Recurring Service</h2>
        </div>
        
        <div style={styles.content}>
          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Initial Service</h3>
            <div style={styles.dateItem}>
              <span style={styles.dateIcon}>🔧</span>
              <span style={styles.dateText}>{initialDate}</span>
              <span style={styles.dateBadge}>Initial Setup</span>
            </div>
          </div>

          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Recurring Services for {monthName}</h3>
            <div style={styles.datesContainer}>
              {currentMonthDates.map((date, idx) => (
                <div key={idx} style={styles.dateItem}>
                  <span style={styles.dateIcon}>🔄</span>
                  <span style={styles.dateText}>{date}</span>
                </div>
              ))}
            </div>
            <div style={styles.totalBadge}>
              Total for {monthName}: {currentMonthDates.length + 1} service orders
            </div>
          </div>

          <div style={styles.warningBox}>
            <div style={styles.warningIcon}>📅</div>
            <div style={styles.warningContent}>
              <strong>Future Months:</strong>
              <p>
                {endDate 
                  ? `Service orders for future months (until ${endDate}) will be generated manually by the administrator at the end of each month.`
                  : 'Service orders for future months will be generated manually by the administrator at the end of each month (no end date set - continues indefinitely).'
                }
              </p>
            </div>
          </div>
        </div>

        <div style={styles.actions}>
          <button onClick={onCancel} style={styles.cancelBtn}>
            Cancel
          </button>
          <button onClick={onConfirm} style={styles.confirmBtn}>
            Confirm & Create Services
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2500
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '600px',
    maxHeight: '85vh',
    overflow: 'hidden',
    boxShadow: '0 10px 50px rgba(0,0,0,0.3)',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    backgroundColor: '#2D5C3F',
    color: 'white',
    padding: '20px',
    borderBottom: '3px solid #D4AF37'
  },
  title: {
    fontSize: '22px',
    margin: 0,
    fontWeight: '700'
  },
  content: {
    padding: '25px',
    overflowY: 'auto',
    flex: 1
  },
  section: {
    marginBottom: '25px'
  },
  sectionTitle: {
    fontSize: '16px',
    color: '#2D5C3F',
    marginBottom: '12px',
    fontWeight: '600',
    borderBottom: '2px solid #E0E0E0',
    paddingBottom: '8px'
  },
  dateItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    backgroundColor: '#F9F9F9',
    borderRadius: '6px',
    marginBottom: '8px',
    border: '1px solid #E0E0E0'
  },
  dateIcon: {
    fontSize: '20px'
  },
  dateText: {
    flex: 1,
    fontSize: '15px',
    fontWeight: '500',
    color: '#333'
  },
  dateBadge: {
    backgroundColor: '#D4AF37',
    color: 'white',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '600'
  },
  datesContainer: {
    maxHeight: '200px',
    overflowY: 'auto',
    marginBottom: '12px'
  },
  totalBadge: {
    backgroundColor: '#2D5C3F',
    color: 'white',
    padding: '10px',
    borderRadius: '6px',
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '14px'
  },
  warningBox: {
    backgroundColor: '#FFF3E0',
    border: '2px solid #FF9800',
    borderRadius: '8px',
    padding: '15px',
    display: 'flex',
    gap: '15px'
  },
  warningIcon: {
    fontSize: '32px',
    flexShrink: 0
  },
  warningContent: {
    flex: 1
  },
  actions: {
    display: 'flex',
    gap: '12px',
    padding: '20px',
    borderTop: '2px solid #f0f0f0'
  },
  cancelBtn: {
    flex: 1,
    padding: '14px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '600',
    color: '#666'
  },
  confirmBtn: {
    flex: 2,
    padding: '14px',
    backgroundColor: '#2D5C3F',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '700'
  }
};

export default RecurringConfirmationModal;
